"use client";

import type { FC } from "react";
import type { Media } from "@mw/shared/payload-types";

import { SideBySideDiscs, toDiscImageConfig } from "@ui/components/core/Disc";
import { getAudioUrl } from "@utilities/payload";

interface DiscConfig {
  audio: Media | string;
  image: Media | string;
  label: string;
}

export interface SideBySideDemoProps {
  leftDisc: DiscConfig;
  rightDisc: DiscConfig;
  /** Source identifier for tracking (e.g., "voice_cloning_demo", "voice_changer_demo") */
  trackingSource?: string;
}

const toSideBySideDiscConfig = (disc: DiscConfig) => {
  const imageConfig = toDiscImageConfig(disc.image);
  return {
    audioUrl: getAudioUrl(disc.audio) ?? "",
    image: imageConfig,
    label: disc.label,
  };
};

const SideBySideDemo: FC<SideBySideDemoProps> = ({ leftDisc, rightDisc, trackingSource }) => (
  <div className='tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center tw-mb-4 md:tw-mb-8'>
    <div className='tw-h-full tw-w-auto tw-aspect-[5/4] tw-max-w-full tw-flex tw-items-center tw-justify-center'>
      <SideBySideDiscs
        leftDisc={toSideBySideDiscConfig(leftDisc)}
        rightDisc={toSideBySideDiscConfig(rightDisc)}
        trackingSource={trackingSource}
      />
    </div>
  </div>
);

export default SideBySideDemo;
